import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

import logoImage from 'assets/icons/logo.png';

type Props = {
  sx?: SxProps<Theme>;
  onClick?: () => void;
};

export function CompanyLogo({ sx, onClick }: Props) {
  return (
    <Box
      component="img"
      src={logoImage}
      alt="Company Logo"
      sx={{
        width: 'auto',
        height: 'auto',
        ...sx,
      }}
      onClick={onClick}
    />
  );
}
